export enum BrandsActionType {
  FETCH_BRANDS = 'FETCH_BRANDS',
  FETCH_SELECTED_BRANDS = 'FETCH_SELECTED_BRANDS',
  FETCH_BRANDS_AFTER_LOGIN = 'FETCH_BRANDS_AFTER_LOGIN'
}
